/*
 * @Description:
 * @Author: dezhi
 * @Date: 2019-10-21 16:27:26
 * @LastEditTime: 2022-11-09 14:50:21
 * @LastEditors: zhaoshuai
 */

import axios from 'axios';
import store from './store';
// import * as types from './store/types'
import router from './router';

// axios 配置
axios.defaults.timeout = 50000;
// -------------------baseUrl 配置-----------------------------
//axios.defaults.baseURL = 'http://101.133.140.196:16000'; //请求url 测试
axios.defaults.baseURL = 'http://47.103.158.90:16000'; //请求url 生产机

// http request 拦截器
axios.interceptors.request.use(
	(config) => {
		config.url = `${config.url.split('?')[0]}?t=${Date.parse(new Date()) /
			1000}&${config.url.split('?')[1]}`;
		config.headers.X_AUTH_TOKEN = localStorage.getItem('apply_token');
		config.headers.PROJECT_ID = 10002;
		return config;
	},
	(err) => {
		return Promise.reject(err);
	}
);

// http response 拦截器
axios.interceptors.response.use(
	(response) => {
		if (response.data.status == 5001 || response.data.status == 5000) {
			store.commit('account/logout');
			// msgTip({
			//     type: 3,
			//     msg: response.data.message
			// });
			router.replace({
				path: '/login',
				query: { redirect: router.currentRoute.path },
			});
		} else {
			// msgTip({
			//     type: 3,
			//     msg: response.data.message
			// });
		}
		return response;
	},
	(error) => {
		if (error.response) {
			switch (error.response.status) {
				case 401:
					// 401 清除token信息并跳转到登录页面
					// store.commit(types.LOGOUT)
					// 只有在当前路由不是登录页面才跳转
					router.currentRoute.path !== 'login' &&
						router.replace({
							path: '/login',
							query: { redirect: router.currentRoute.path },
						});
			}
		}
		// console.log(JSON.stringify(error));//console : Error: Request failed with status code 402
		return Promise.reject(error.response.data);
	}
);

export default axios;
